var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPARKINGAPP = CONFUSEDPARKINGAPP || {};
CONFUSEDPARKINGAPP.Search = CONFUSEDPARKINGAPP.Search || {};

(function (ns, $) {
    'use strict';

    // html elements
    ns.Elements = {
        ParkingAppSearchBox: '#parkingAppSearchBox',
        ParkingAppChangeSearchBox: '#parkingAppChangeSearchBox',
        SearchChangeLocationSelected: '#searchChangeLocationSelected',
        SearchLocationSelected: '#searchLocationSelected'
    };

    // initialise auto-complete
    ns.initAutocomplete = function () {

        // add auto-complete to search box
        var input = null;
        var checkBox = null;

        if ($(ns.Elements.ParkingAppSearchBox).is(':visible')) {
            input = $(ns.Elements.ParkingAppSearchBox).get(0);

            $(input).change(function () {
                $(ns.Elements.SearchLocationSelected).prop('checked', false);
                return false;
            });

            checkBox = ns.Elements.SearchLocationSelected;
        }

        if ($(ns.Elements.ParkingAppChangeSearchBox).is(':visible')) {
            input = $(ns.Elements.ParkingAppChangeSearchBox).get(0);

            $(input).change(function () {
                $(ns.Elements.SearchChangeLocationSelected).prop('checked', false);
                return false;
            });

            checkBox = ns.Elements.SearchChangeLocationSelected;
        }

        if (input === null) {
            return null;
        }

        var options = {
            componentRestrictions: {
                country: 'uk'
            }
        };

        google.maps.event.clearInstanceListeners(input);

        var autocomplete = new google.maps.places.Autocomplete(input, options);

        google.maps.event.addListener(autocomplete, 'place_changed', function () {
            $(checkBox).prop('checked', true);
            return true;
        });

        return autocomplete;
    };

    // get Google Place
    ns.getPlace = function (autocomplete) {

        var place = autocomplete.getPlace();

        if (place === null || place === undefined || !place.geometry) {
            CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('AutocompleteGetPlaceFailed');
            return null;
        } else {
            CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('AutocompleteGetPlace');
        }

        return place;
    };

}(CONFUSEDPARKINGAPP.Search, jQuery));